import { render, staticRenderFns } from "./processFlowDiagram.vue?vue&type=template&id=20c16cca&scoped=true"
import script from "./processFlowDiagram.vue?vue&type=script&lang=js"
export * from "./processFlowDiagram.vue?vue&type=script&lang=js"
import style0 from "./processFlowDiagram.vue?vue&type=style&index=0&id=20c16cca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c16cca",
  null
  
)

export default component.exports